import React from "react";
import { Modal, Box, Typography, IconButton, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function UploadCompleteModal({
    open,
    onClose,
}) {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    display: "grid",
                    placeItems: "center",
                    p: 2
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        width: { xs: "95vw", sm: "80vw", md: "60vw" },
                        height: { xs: "70vh", sm: "60vh", md: "55vh" },
                        maxWidth: 1000,
                        bgcolor: "#000",
                        borderRadius: 4,
                        border: "1px solid rgba(255,255,255,0.7)",
                        color: "#fff",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        px: 4
                    }}
                >

                    {/* botón cerrar */}
                    <IconButton
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            top: 20,
                            right: 20,
                            width: 44,
                            height: 44,
                            border: "1px solid rgba(255,255,255,0.7)",
                            color: "#fff"
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* título */}
                    <Typography
                        sx={{
                            fontSize: 34,
                            mb: 2
                        }}
                    >
                        Files uploaded successfully
                    </Typography>

                    {/* descripción */}
                    <Typography
                        sx={{
                            maxWidth: 520,
                            opacity: 0.8,
                            mb: 4,
                            fontSize: 16,
                            lineHeight: 1.6
                        }}
                    >
                        You will receive an email with a link where you can view your results once they are ready.
                    </Typography>

                    {/* botón */}
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            borderRadius: "999px",
                            px: 6,
                            py: 1.3,
                            fontSize: 16,
                            textTransform: "none",
                            color: "#fff",
                            borderColor: "rgba(255,255,255,0.7)",
                            "&:hover": {
                                borderColor: "white",
                                background: "rgba(255,255,255,0.05)"
                            }
                        }}
                    >
                        Return
                    </Button>

                </Box>
            </Box>
        </Modal>
    );
}